module.exports = __webpack_public_path__ + "img/7.13e2f329.jpg";